<template>
  <div>
    <div class="relative mt-4">
      <new-table-lite
        class="admin-table summary Totals"
        :is-loading="table.isLoading"
        :is-static-mode="true"
        :is-slot-mode="true"
        :columns="columnsOrder"
        :rows="table.rows"
        :rowClasses="row => row.orderNumber ? 'cursor-pointer id-' + row.orderNumber : null"
        :total="table.totalRecordCount"
        :sortable="table.sortable"
        @is-finished="table.isLoading = false"
        :page-size="table.pagesize"
        :pageOptions="table.pageOptions"
        :has-checkbox="false"
        @row-clicked="setActive"
        :is-hide-paging="false"
        :pageSizeChangeLabel="'pageSizeChangeLabel'"
        :messages="tableMessages"
      >
        <template v-slot:filter>
          <tr class="vtl-thead-tr z-20">
            <td class="vtl-tbody-td">
              <span>Totals</span>
            </td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalInvoice) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.grossSale) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.subTotal) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalDiscount) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalOtherDiscount) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalPromotionDiscount) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalPromoCodeDiscount) }}</td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td">{{ sumPayload.totalMembershipRedemptions }}</td>
            <td class="vtl-tbody-td">{{ sumPayload.rewardRedemption }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalTax) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalFees) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalTips) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalCost) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.grossProfit) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.grossProfit/sumPayload.subTotal*100) }}</td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.cash) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.amex) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.master) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.visa) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.debit) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.uber) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.gift_card) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.other) }}</td>
          </tr>
        </template>

        <template v-slot:completedDate="data">
          <span v-if="data.value.completedDate">{{ canadaTime(data.value.completedDate) }}</span>
        </template>
        <template v-slot:totalInvoice="data">
          <span>{{ displayPriceFormat(data.value.totalInvoice) }}</span>
        </template>
        <template v-slot:subTotal="data">
          <span>{{ displayPriceFormat(data.value.subTotal) }}</span>
        </template>
        <template v-slot:totalDiscount="data">
          <span>{{ displayPriceFormat(data.value.totalDiscount) }}</span>
        </template>
        <template v-slot:totalOtherDiscount="data">
          <span>{{ displayPriceFormat(data.value.totalOtherDiscount) }}</span>
        </template>
        <template v-slot:totalPromotionDiscount="data">
          <span>{{ displayPriceFormat(data.value.totalPromotionDiscount) }}</span>
        </template>
        <template v-slot:totalPromoCodeDiscount="data">
          <span>{{ displayPriceFormat(data.value.totalPromoCodeDiscount) }}</span>
        </template>
        <template v-slot:totalTax="data">
          <span>{{ displayPriceFormat(data.value.totalTax) }}</span>
        </template>
        <template v-slot:totalFees="data">
          <span>{{ displayPriceFormat(data.value.totalFees) }}</span>
        </template>
        <template v-slot:totalTips="data">
          <span>{{ displayPriceFormat(data.value.totalTips) }}</span>
        </template>
        <template v-slot:totalCost="data">
          <span>{{ displayPriceFormat(data.value.totalCost) }}</span>
        </template>
        <template v-slot:grossProfit="data">
          <span>{{ displayPriceFormat(data.value.grossProfit) }}</span>
        </template>
        <template v-slot:grossMargin="data">
          <span>{{ displayPriceFormat(data.value.grossMargin) }}</span>
        </template>
        <template v-slot:paymentType="data">
          <span>{{ paymentType(data.value) }}</span>
        </template>
        <template v-slot:cash="data">
          <span>{{ displayPriceFormat(data.value.cash) }}</span>
        </template>
        <template v-slot:amex="data">
          <span>{{ displayPriceFormat(data.value.amex) }}</span>
        </template>
        <template v-slot:master="data">
          <span>{{ displayPriceFormat(data.value.master) }}</span>
        </template>
        <template v-slot:vis="data">
          <span>{{ displayPriceFormat(data.value.visa) }}</span>
        </template>
        <template v-slot:debit="data">
          <span>{{ displayPriceFormat(data.value.debit) }}</span>
        </template>
        <template v-slot:uber="data">
          <span>{{ displayPriceFormat(data.value.uber) }}</span>
        </template>
        <template v-slot:gift_card="data">
          <span>{{ data.value.gift_card }}</span>
        </template>
        <template v-slot:other="data">
          <span>{{ displayPriceFormat(data.value.other) }}</span>
        </template>
      </new-table-lite>
    </div>
    <sales-detail v-if="detailPop" :closeClick="closeDetailModal" :item="item" />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import Env from '@/env'
import StringHelpers from '@/helpers/string'
import moment from 'moment-timezone'
import salesDetail from './Detail.vue'
import { mapGetters } from 'vuex'
import NewTableLite from '@/components/table/tableLite.vue'

const tableMessages = {
  pagingInfo: 'Total: {2}',
  pageSizeChangeLabel: 'Items per Page',
  gotoPageLabel: '',
  noDataAvailable: 'No records found!',
}

export default defineComponent({
  components: {
    salesDetail,
    NewTableLite,
  },
  props: {
    payload: {
      type: Array,
      required: false,
      default: () => [],
    },
    sumPayload: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  setup() {
    const detailPop = ref(false)
    const item = ref({})
    const columnsOrder = ref([
      {
        label: 'Location',
        field: 'location',
        sortable: false,
      },
      {
        isKey: true,
        label: 'Order ID',
        field: 'orderNumber',
        sortable: false,
        headerClasses: 'width',
      },
      {
        label: 'Date & Time',
        field: 'completedDate',
        sortable: false,
      },
      {
        label: 'Order Status',
        field: 'type',
        sortable: false,
      },
      {
        label: 'POS Station',
        field: 'posStationName',
        sortable: false,
      },
      {
        label: 'Delivery',
        field: 'delivery',
        sortable: false,
      },
      {
        label: 'Online/In-Store',
        field: 'orderReceiveMethod',
        sortable: false,
      },
      {
        label: 'Platform',
        field: 'platform',
        sortable: false,
      },
      {
        label: 'Total Receipts',
        field: 'totalInvoice',
        sortable: false,
      },
      {
        label: 'Gross Sale',
        field: 'grossSale',
        sortable: false,
      },
      {
        label: 'Net Sales',
        field: 'subTotal',
        sortable: false,
      },
      {
        label: 'Total Discounts',
        field: 'totalDiscount',
        sortable: false,
      },
      {
        label: 'Total Other Discounts',
        field: 'totalOtherDiscount',
        sortable: false,
      },
      {
        label: 'Total Promotion Discounts',
        field: 'totalPromotionDiscount',
        sortable: false,
      },
      {
        label: 'Total Promo Code Discounts',
        field: 'totalPromoCodeDiscount',
        sortable: false,
      },
      {
        label: 'Discount Reason',
        field: 'discountReason',
        sortable: false,
      },
      {
        label: 'Total Membership Redemptions',
        field: 'totalMembershipRedemptions',
        sortable: false,
      },
      {
        label: 'Reward Tiers',
        field: 'rewardRedemption',
        sortable: false,
      },
      {
        label: 'Total Tax',
        field: 'totalTax',
        sortable: false,
      },
      {
        label: 'Total Fees',
        field: 'totalFees',
        sortable: false,
      },
      {
        label: 'Total Tips',
        field: 'totalTips',
        sortable: false,
      },
      {
        label: 'Cost of Goods Sold',
        field: 'totalCost',
        sortable: false,
      },
      {
        label: 'Gross Profit',
        field: 'grossProfit',
        sortable: false,
      },
      {
        label: 'Gross Margin',
        field: 'grossMargin',
        sortable: false,
      },
      {
        label: 'Tendered By',
        field: 'tenderedBy',
        sortable: false,
      },
      {
        label: 'Created By',
        field: 'createdBy',
        sortable: false,
      },
      {
        label: 'Customer',
        field: 'customer',
        sortable: false,
      },
      {
        label: 'Payment Type',
        field: 'paymentType',
        sortable: false,
      },
      {
        label: 'Cash',
        field: 'cash',
        sortable: false,
      },
      {
        label: 'Amex',
        field: 'amex',
        sortable: false,
      },
      {
        label: 'Mastercard',
        field: 'master',
        sortable: false,
      },
      {
        label: 'Visa',
        field: 'vis',
        sortable: false,
      },
      {
        label: 'Debit',
        field: 'debit',
        sortable: false,
      },
      {
        label: 'Uber',
        field: 'uber',
        sortable: false,
      },
      {
        label: 'Gift card',
        field: 'gift_card',
        sortable: false,
      },
      {
        label: 'Other',
        field: 'other',
        sortable: false,
      },
    ])
    const table = ref({
      isLoading: false,
      rows: [],
      totalRecordCount: 0,
      sortable: {
        order: 'name',
        sort: 'asc',
      },
      pagesize: Env.defaultPageSize,
      pageOptions: Env.pageList,
      count: 0,
      page: 1,
    })

    return {
      table,
      columnsOrder,
      item,
      detailPop,
      tableMessages,
    }
  },
  computed: {
    ...mapGetters({
      vg_selectedLocation: 'location/selected',
    }),
  },
  mounted() {
    this.load()
    this.emitter.on('reloadSalesList', this.reload)
  },
  beforeDestroy() {
    this.emitter.off('reloadSalesList', this.reload)
  },
  methods: {
    displayPriceFormat(price) {
      return StringHelpers.roundOff(price, 2)
    },
    reload() {
      this.$nextTick(() => {
        this.load()
      })
    },
    load() {
      this.table.rows = this.payload
      this.table.totalRecordCount = this.payload.length
      this.table.isLoading = false
    },
    canadaTime(data) {
      if (!data) return
      const defaultTimeZone = this.vg_selectedLocation.timezone ? this.vg_selectedLocation.timezone : 'America/Toronto'
      return moment(data).tz(defaultTimeZone).format('YYYY-MM-DD h:mm a')
    },
    paymentType(data) {
      if([data.amex, data.visa, data.mastercard, data.debit, data.cash, data.otherCard].filter(Boolean).length>1) {
        return 'Split'
      } else {
        if (data.amex) {
          return 'Amex'
        } else if (data.visa) {
          return 'Visa'
        } else if (data.mastercard) {
          return 'Mastercard'
        } else if (data.debit) {
          return 'Debit'
        } else if (data.cash) {
          return 'Cash'
        } else if (data.otherCard) {
          return 'Other'
        } else {
          return ''
        }
      }
    },
    setActive(row) {
      if (row.orderNumber) {
        const activeRow = document.getElementsByClassName('id-' + row.orderNumber)
        if (activeRow[0] && activeRow[0].parentNode && activeRow[0].parentNode.children) {
          for (const sibling of activeRow[0].parentNode.children) {
            sibling.classList.remove('active-row')
          }
        }
        activeRow[0].classList.add('active-row')

        this.item = row
        this.openDetailModal()
      }
    },
    openDetailModal() {
      this.detailPop = true
    },
    closeDetailModal() {
      this.detailPop = false
    },
  },
})
</script>
